import React from "react";
import { connect } from "react-redux";
import { DashboardCard, ChartCard } from "./DashboardCard";
import DonutChart from "./DonutChart";
import HeatMap from "./HeatMap";
import SalariesChart from "./SalariesChart";
import JoinersLeaversChart from "./JoinersLeaversChart";

const Dashboard = ({ currency }) => {
	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Dashboard</h1>
						</div>
					</div>
				</div>
			</div>
			<div style={{ gap: "20px" }}>
				<div
					className="grid justify-evenly items-center width-full grid-cols-5 p-4 wrap"
					style={{ gap: "10px" }}
				>
					<div
						className="width-full col-span-1"
						style={{
							gap: "10px",
						}}
					>
						<DashboardCard
							title={"August Overview"}
							value={currency + "134,492"}
						/>
						<DashboardCard
							title={"Highest Paid Department"}
							value={currency + "45,368"}
							subtitle={"Development"}
						/>
					</div>
					<div className="width-full col-span-2">
						<ChartCard
							title={"Excluding Base Hours"}
							chart={<DonutChart currency={currency} />}
						/>
					</div>
					<div className="width-full col-span-2">
						<ChartCard
							title={"Leave Heat Map"}
							chart={<HeatMap />}
						/>
					</div>
				</div>
				<div
					className="width-full p-4 grid grid-cols-6 wrap"
					style={{ gap: "20px" }}
				>
					<div className="col-span-2">
						<ChartCard
							title={"Salaries"}
							chart={<SalariesChart />}
						/>
					</div>
					<div className="col-span-4">
						<ChartCard
							title={"Joiners vs Leavers"}
							chart={<JoinersLeaversChart />}
						/>
					</div>
				</div>
			</div>
			<div className="clearfix" />
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		currency: state.company?.settings?.currency,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
